module.exports = __webpack_public_path__ + "img/mtlawley.5ff1fe5c.jpg";